import { render } from "./SchedaUtente.vue?vue&type=template&id=d0963042&scoped=true"
import script from "./SchedaUtente.vue?vue&type=script&lang=js"
export * from "./SchedaUtente.vue?vue&type=script&lang=js"

import "./SchedaUtente.vue?vue&type=style&index=0&id=d0963042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0963042"]])

export default __exports__